export default __webpack_public_path__ + "static/media/document-logo-4-active.1e531c18.svg";